<section class="container">
<div class="card">
  <div class="card-icon">
    <fa-icon *ngIf="cardIcon" [icon]="cardIcon"></fa-icon>    
    <img *ngIf="!cardIcon" class="img-cont" [src]="imgPath"/>
  </div>

  <div class="card-body">
    <h5 class="card-title">{{ cardTitle }}</h5>
  </div>
</div>
</section>